export default {"src":"/_next/static/media/check.46a01da4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};